import { AlertTriangle } from 'lucide-react';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';

/**
 * Confirmation d'un geste UNITAIRE irréversible (supprimer un actif, un compte…).
 *
 * Remplace les `window.confirm()` des écrans à sélection multiple. Une alerte du
 * navigateur ne peut ni nommer proprement la cible, ni porter un avertissement, ni se
 * teindre en rouge : la suppression et l'archivage y ont exactement la même tête.
 *
 * Restent à migrer, hors périmètre de ce chantier (écrans sans édition en masse) :
 * ClientDetailPage, MenusPage.
 *
 * @param {object} pending  { title, target, message, warning, confirmLabel } — null = fermé
 */
export default function ConfirmDialog({ pending, onCancel, onConfirm, busy }) {
  const open = !!pending;

  return (
    <Dialog open={open} onOpenChange={o => { if (!o) onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle>{pending?.title || 'Confirmer'}</DialogTitle>
        </DialogHeader>

        {pending && (
          <div className="space-y-3 text-[13px]">
            {pending.target && (
              <div className="p-3 rounded-md bg-neutral-50 border border-neutral-100">
                <p className="text-[11px] text-neutral-400">{pending.targetLabel || 'Élément ciblé'}</p>
                <p className="font-medium text-neutral-900">{pending.target}</p>
              </div>
            )}

            {pending.message && <p className="text-neutral-700">{pending.message}</p>}

            <div className="flex items-start gap-2 p-3 rounded-md bg-amber-50 border border-amber-100 text-[12px] text-amber-800">
              <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-600" />
              <span>{pending.warning || "Cette action ne peut pas être annulée."}</span>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="confirm-cancel-btn">Annuler</Button>
          <Button
            variant={pending?.tone === 'danger' ? 'destructive' : 'default'}
            disabled={busy}
            onClick={onConfirm}
            data-testid="confirm-accept-btn"
          >
            {pending?.confirmLabel || 'Confirmer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
